import Radio from './radio';

/* istanbul ignore next */
Radio.install = function(Vue) {
  Vue.component('ZmRadio', Radio);
};

export default Radio;
